export const APP_OPTIONS = [
  { value: 'all',      label: 'All Apps' },
  { value: 'flexus',   label: 'Flexus' },
  { value: 'ecency',   label: 'Ecency' },
  { value: 'inleo',    label: 'InLeo' },
  { value: 'peakd',    label: 'PeakD' },
  { value: 'hiveblog', label: 'hive.blog' },
  { value: 'liketu',   label: 'Liketu' },
  { value: 'other',    label: 'Other' },
];
